import Vue from 'vue'
import Breadcrumbs from '../components/Breadcrumbs.vue'
Vue.mixin({
    methods: {
        setBreadcrumbsParam(param) {
            Breadcrumbs.setParam(param)
        }
    }
})